import React from 'react';

import { Icon } from '@chakra-ui/react';
import { MdLock } from 'react-icons/md';
import {
  FaCalendarAlt,
  FaUserAlt,
  FaCar,
  FaShoppingCart,
  FaMoneyBillWave,
  FaChartLine,
  FaFileInvoiceDollar,
  FaFileAlt,
  FaFileInvoice,
  FaReceipt,
  FaCogs,
  FaCalendarCheck,
  FaClipboardList,
  FaCube,
  FaUsers,
  FaUserShield,
  FaShieldAlt,
  FaTruck,
  FaPlus,
  FaCalendarPlus,
} from 'react-icons/fa';
import {
  MdBuild,
  MdEvent,
  MdInventory,
  MdColorLens,
  MdLocalGasStation,
  MdBrandingWatermark,
  MdCampaign,
  MdSchedule,
} from 'react-icons/md';

// Admin Imports
import Clients from './views/admin/clients';
import Providers from './views/admin/providers';
import Vehicles from './views/admin/vehicles';
import Products from './views/admin/products';
import Events from './views/admin/events';
import Appointment from './views/admin/appointment';
import Services from './views/admin/services';
import ServicesHistory from './views/admin/servicesList';
import Warranty from './views/admin/warranty';
import Invoices from './views/admin/invoices';
import CreateInvoices from './views/admin/createInvoice';
import InvoiceTemplatesPage from './views/admin/invoiceTemplates';
import CreateCreditNote from './views/admin/createCreditNote';
import CreditNotes from './views/admin/creditNotes';
import PurchaseInvoices from './views/admin/purchaseInvoices';
import NewPurchaseInvoice from './views/admin/newPurchaseInvoice';
import ProviderPayments from './views/admin/providerPayments';
import CustomerPayments from './views/admin/customerPayments';
import AccountStatement from './views/admin/accountStatement';
import AccountStatementClientsRedirect from './views/admin/accountStatementClients';
import Colors from './views/admin/colors';
import FuelType from './views/admin/fuelTypes';
import Brands from './views/admin/brand';
import Models from './views/admin/models';
import Campaigns from './views/admin/campaigns';
import RoleManagement from './views/admin/roleManagement';
import UserManagement from './views/admin/userManagement';
import StockAdmin from './views/admin/stock';
import StockControlPage from './views/admin/stock/control';
import HolidaysAdmin from './views/admin/holidays';
import InactiveCustomersReport from './views/admin/reports/inactiveCustomers';
import ReportsHome from './views/admin/reports';
import CemReport from './views/admin/reports/cem';
import ProductivityReport from './views/admin/reports/productivity';
import SbsReport from './views/admin/reports/sbs';
import SbsConfigReport from './views/admin/reports/sbsConfig';

// Auth Imports
import SignInCentered from 'views/auth/signIn';
import Scheduler from 'views/admin/scheduler';

const routes = [
  {
    name: 'Agenda',
    category: true,
    layout: '/admin',
    requiredPermissions: ['schedule.view_all', 'schedule.view_own'],
    requireAny: true, // Solo necesita uno de los permisos
    icon: (
      <Icon as={MdSchedule} width="20px" height="20px" color="inherit" />
    ),
    items: [
      {
        name: 'Calendario',
        layout: '/admin',
        requiredPermissions: ['schedule.view_all', 'schedule.view_own'],
        requireAny: true,
        icon: (
          <Icon as={FaCalendarAlt} width="20px" height="20px" color="inherit" />
        ),
        path: '/default',
        component: <Scheduler />,
        showSearch: false,
      },
      {
        name: 'Agendar servicio',
        layout: '/admin',
        requiredPermissions: ['schedule.create'],
        icon: (
          <Icon as={FaCalendarPlus} width="20px" height="20px" color="inherit" />
        ),
        path: '/appointment',
        component: <Appointment />,
        showSearch: false,
      },
      {
        name: 'Listado de servicios',
        layout: '/admin',
        requiredPermissions: ['services.view'],
        excludeRoles: ['Mecanico'],
        icon: (
          <Icon as={FaClipboardList} width="20px" height="20px" color="inherit" />
        ),
        path: '/serviceshistory',
        component: <ServicesHistory />,
        showSearch: true,
        showDateFilter: true,
      },
      {
        name: 'Días bloqueados',
        layout: '/admin',
        requiredPermissions: ['holidays.view', 'schedule.create'],
        icon: (
          <Icon as={FaCalendarCheck} width="20px" height="20px" color="inherit" />
        ),
        path: '/holidays',
        component: <HolidaysAdmin />,
        showSearch: false,
      },
    ],
  },
  {
    name: 'Clientes',
    layout: '/admin',
    requiredPermissions: ['clients.view'],
    icon: <Icon as={FaUserAlt} boxSize="20px" color="inherit" />,
    path: '/clients',
    component: <Clients />,
    showSearch: true,
  },
  {
    name: 'Vehículos',
    layout: '/admin',
    requiredPermissions: ['vehicles.view'],
    icon: <Icon as={FaCar} boxSize="20px" color="inherit" />,
    path: '/vehicles',
    component: <Vehicles />,
    showSearch: true,
  },
  {
    name: 'Campañas',
    layout: '/admin',
    requiredPermissions: ['campaigns.view'],
    onlyRoles: ['Mecanico'],
    menuOnly: true,
    icon: <Icon as={MdCampaign} width="20px" height="20px" color="inherit" />,
    path: '/campaigns',
    showSearch: true,
  },
  {
    name: 'Listado productos',
    layout: '/admin',
    requiredPermissions: ['products.view'],
    onlyRoles: ['Mecanico'],
    menuOnly: true,
    icon: <Icon as={MdInventory} width="20px" height="20px" color="inherit" />,
    path: '/products',
    showSearch: true,
  },
  {
    name: 'Garantías',
    layout: '/admin',
    requiredPermissions: ['warranties.view'],
    icon: <Icon as={FaShieldAlt} boxSize="20px" color="inherit" />,
    path: '/warranty',
    component: <Warranty />,
    showSearch: true,
    showDateFilter: true,
  },
  {
    name: 'Facturas',
    category: true,
    layout: '/admin',
    requiredPermissions: ['invoices.view'],
    icon: (
      <Icon as={FaFileInvoiceDollar} width="20px" height="20px" color="inherit" />
    ),
    items: [
      {
        name: 'Emitir factura',
        layout: '/admin',
        requiredPermissions: ['invoices.create'],
        icon: (
          <Icon as={FaPlus} width="20px" height="20px" color="inherit" />
        ),
        path: '/create-invoices',
        component: <CreateInvoices />,
        showSearch: false,
      },
      {
        name: 'Plantillas factura (Demo)',
        layout: '/admin',
        requiredPermissions: ['invoices.create'],
        icon: (
          <Icon as={FaFileAlt} width="20px" height="20px" color="inherit" />
        ),
        path: '/invoice-templates',
        component: <InvoiceTemplatesPage />,
        showSearch: false,
      },
      {
        name: 'Crear nota de crédito',
        layout: '/admin',
        requiredPermissions: ['invoices.create'],
        icon: (
          <Icon as={FaFileAlt} width="20px" height="20px" color="inherit" />
        ),
        path: '/create-credit-note',
        component: <CreateCreditNote />,
        showSearch: false,
      },
      {
        name: 'Facturas emitidas',
        layout: '/admin',
        requiredPermissions: ['invoices.view'],
        icon: (
          <Icon as={FaFileInvoice} width="20px" height="20px" color="inherit" />
        ),
        path: '/emited-invoices',
        component: <Invoices />,
        showSearch: false,
      },
      {
        name: 'Notas de crédito',
        layout: '/admin',
        requiredPermissions: ['invoices.view'],
        icon: (
          <Icon as={FaReceipt} width="20px" height="20px" color="inherit" />
        ),
        path: '/credit-notes',
        component: <CreditNotes />,
        showSearch: false,
      },
      {
        name: 'Recibos',
        layout: '/admin',
        requiredPermissions: ['invoices.create'],
        icon: (
          <Icon as={FaMoneyBillWave} width="20px" height="20px" color="inherit" />
        ),
        path: '/customer-payments',
        component: <CustomerPayments />,
        showSearch: false,
      },
      {
        name: 'Estado de cuenta clientes',
        layout: '/admin',
        requiredPermissions: ['invoices.view'],
        icon: (
          <Icon as={FaChartLine} width="20px" height="20px" color="inherit" />
        ),
        path: '/account-statement-clients',
        component: <AccountStatementClientsRedirect />,
        showSearch: false,
      },
    ],
  },
  {
    name: 'Compras y Pagos',
    category: true,
    layout: '/admin',
    requiredPermissions: ['providers.view', 'invoices.view'],
    requireAny: true,
    icon: (
      <Icon as={FaShoppingCart} width="20px" height="20px" color="inherit" />
    ),
    items: [
      {
        name: 'Nueva factura de compra',
        layout: '/admin',
        requiredPermissions: ['providers.view'],
        icon: (
          <Icon as={FaPlus} width="20px" height="20px" color="inherit" />
        ),
        path: '/purchase-invoices/new',
        component: <NewPurchaseInvoice />,
        showSearch: false,
      },
      {
        name: 'Facturas de compra',
        layout: '/admin',
        requiredPermissions: ['providers.view'],
        icon: (
          <Icon as={FaShoppingCart} width="20px" height="20px" color="inherit" />
        ),
        path: '/purchase-invoices',
        component: <PurchaseInvoices />,
        showSearch: true,
      },
      {
        name: 'Pagos a proveedores',
        layout: '/admin',
        requiredPermissions: ['providers.manage'],
        icon: (
          <Icon as={FaMoneyBillWave} width="20px" height="20px" color="inherit" />
        ),
        path: '/provider-payments',
        component: <ProviderPayments />,
        showSearch: false,
      },
      {
        name: 'Estado de cuenta',
        layout: '/admin',
        requiredPermissions: ['providers.view'],
        icon: (
          <Icon as={FaChartLine} width="20px" height="20px" color="inherit" />
        ),
        path: '/account-statement',
        component: <AccountStatement />,
        showSearch: false,
      },
    ],
  },
  {
    name: 'Proveedores',
    layout: '/admin',
    requiredPermissions: ['providers.view'],
    icon: <Icon as={FaTruck} boxSize="20px" color="inherit" />,
    path: '/providers',
    component: <Providers />,
    showSearch: true,
  },
  {
    name: 'Productos',
    category: true,
    layout: '/admin',
    requiredPermissions: ['products.view'],
    icon: (
      <Icon as={MdInventory} width="20px" height="20px" color="inherit" />
    ),
    items: [
      {
        name: 'Listado productos',
        layout: '/admin',
        requiredPermissions: ['products.view'],
        excludeRoles: ['Mecanico'],
        icon: (
          <Icon as={MdInventory} width="20px" height="20px" color="inherit" />
        ),
        path: '/products',
        component: <Products />,
        showSearch: true,
      },
      {
        name: 'Inventario/stock',
        layout: '/admin',
        requiredPermissions: ['products.view'],
        excludeRoles: ['Mecanico'],
        icon: (
          <Icon as={MdInventory} width="20px" height="20px" color="inherit" />
        ),
        path: '/stock',
        component: <StockAdmin />,
        showSearch: false,
      },
      {
        name: 'Control de stock',
        layout: '/admin',
        requiredPermissions: ['products.view'],
        excludeRoles: ['Mecanico'],
        path: '/stock/control',
        component: <StockControlPage />,
        showInNavbar: false,
        showSearch: false,
      },
    ],
  },
  {
    name: 'Recursos',
    category: true,
    layout: '/admin',
    icon: <Icon as={FaCogs} width="20px" height="20px" color="inherit" />,
    items: [
      {
        name: 'Servicios',
        layout: '/admin',
        requiredPermissions: ['config.view', 'services.manage'],
        requireAny: true,
        icon: <Icon as={MdBuild} width="20px" height="20px" color="inherit" />,
        path: '/services',
        component: <Services />,
        showSearch: true,
      },
      {
        name: 'Eventos',
        layout: '/admin',
        requiredPermissions: ['config.view', 'products.edit'],
        requireAny: true,
        icon: (
          <Icon as={MdEvent} width="20px" height="20px" color="inherit" />
        ),
        path: '/events',
        component: <Events />,
        showSearch: true,
      },
      {
        name: 'Colores',
        layout: '/admin',
        requiredPermissions: ['config.view', 'products.edit'],
        requireAny: true,
        icon: (
          <Icon as={MdColorLens} width="20px" height="20px" color="inherit" />
        ),
        path: '/colors',
        component: <Colors />,
        showSearch: true,
      },
      {
        name: 'Combustibles',
        layout: '/admin',
        requiredPermissions: ['config.view', 'products.edit'],
        requireAny: true,
        icon: (
          <Icon as={MdLocalGasStation} width="20px" height="20px" color="inherit" />
        ),
        path: '/fuelTypes',
        component: <FuelType />,
        showSearch: true,
      },
      {
        name: 'Marcas',
        layout: '/admin',
        requiredPermissions: ['config.view', 'products.edit'],
        requireAny: true,
        icon: (
          <Icon as={MdBrandingWatermark} width="20px" height="20px" color="inherit" />
        ),
        path: '/brands',
        component: <Brands />,
        showSearch: true,
      },
      {
        name: 'Modelos',
        layout: '/admin',
        requiredPermissions: ['config.view', 'products.edit'],
        requireAny: true,
        icon: (
          <Icon as={FaCube} width="20px" height="20px" color="inherit" />
        ),
        path: '/models',
        component: <Models />,
        showSearch: true,
      },
      {
        name: 'Campañas',
        layout: '/admin',
        requiredPermissions: ['campaigns.view'],
        excludeRoles: ['Mecanico'],
        icon: <Icon as={MdCampaign} width="20px" height="20px" color="inherit" />,
        path: '/campaigns',
        component: <Campaigns />,
        showSearch: true,
      },
    ],
  },
  {
    name: 'Reportes',
    layout: '/admin',
    requiredPermissions: ['reports.view'],
    icon: <Icon as={FaChartLine} boxSize="20px" color="inherit" />,
    path: '/reports',
    component: <ReportsHome />,
    showSearch: false,
  },
  {
    name: 'Reporte CEM',
    layout: '/admin',
    requiredPermissions: ['reports.view'],
    path: '/reports/cem',
    component: <CemReport />,
    showSearch: false,
    showInNavbar: false,
  },
  {
    name: 'Productividad',
    layout: '/admin',
    requiredPermissions: ['reports.view'],
    path: '/reports/productivity',
    component: <ProductivityReport />,
    showSearch: false,
    showInNavbar: false,
  },
  {
    name: 'Clientes sin visita',
    layout: '/admin',
    requiredPermissions: ['reports.view'],
    path: '/reports/inactive-customers',
    component: <InactiveCustomersReport />,
    showSearch: false,
    showInNavbar: false,
  },
  {
    name: 'Reporte SBS',
    layout: '/admin',
    requiredPermissions: ['reports.view'],
    path: '/reports/sbs',
    component: <SbsReport />,
    showSearch: false,
    showInNavbar: false,
  },
  {
    name: 'Configuración SBS',
    layout: '/admin',
    requiredPermissions: ['reports.view'],
    path: '/reports/sbs-config',
    component: <SbsConfigReport />,
    showSearch: false,
    showInNavbar: false,
  },
  {
    name: 'Administración',
    category: true,
    layout: '/admin',
    requiredRole: 'Admin', // Solo Admin puede ver administración
    icon: <Icon as={FaUserShield} width="20px" height="20px" color="inherit" />,
    items: [
      {
        name: 'Usuarios',
        layout: '/admin',
        requiredRole: 'Admin',
        requiredPermissions: ['users.view'],
        icon: <Icon as={FaUsers} width="20px" height="20px" color="inherit" />,
        path: '/user-management',
        component: <UserManagement />,
        showSearch: false,
      },
      {
        name: 'Roles',
        layout: '/admin',
        requiredRole: 'Admin',
        requiredPermissions: ['roles.view'],
        icon: <Icon as={FaUserShield} width="20px" height="20px" color="inherit" />,
        path: '/role-management',
        component: <RoleManagement />,
        showSearch: false,
      },
    ],
  },
  {
    name: 'Sign In',
    layout: '/auth',
    path: '/sign-in',
    icon: <Icon as={MdLock} width="20px" height="20px" color="inherit" />,
    component: <SignInCentered />,
    showSearch: false,
  },
];

export default routes;
